import React from "react";

export default function SQL_Home() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Home</h1>
      <p>This is the SQL_Home component generated from the SQL JSON.</p>
    </div>
  );
}
